<template>
  <div class="margin-bottom-150">
    <div class="top-bar">
      <span @click="cancel">
        <i class="left"></i>
      </span>
      <span class="heading_new">History</span>
      <span class="spacer" />
    </div>

    <div class="card margintop-30">
      <div class="image">
        <img src="@/assets/user.svg" class="alignImage" />
      </div>
      <div class="emp-details">
        <span>
          <b>{{employeeObject.name}}</b>
        </span>
        <br />
        <span class="details">{{employeeObject.code}}</span>
        <br />
        <span class="details">{{employeeObject.email_id}}</span>
        <br />
        <br />
      </div>
    </div>

    <div class="table-container" v-for="(log, index) in updatedArray" :key="index">
      <tl-accordion :headerName="`Revised on ${log.revised_date}`" :active="true">
        <div slot="accordionBody">
          <data-table :columns="employeeTableColumns" :tableData="log.log_details" :showinrow="false" class="margin-bottom-30">
            <!-- <template v-slot:rowcontent="slotprops">
              <p
                v-if="slotprops.value.column.key=='amount'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key=='name'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
            </template> -->
          </data-table>
        </div>
      </tl-accordion>
    </div>

    <footer>
      <bottom-action-container>
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Back" type="secondary" @click="cancel" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      employeeObject: {
        id: null,
        name: null,
        code: null,
        email_id: null,
        assignedComponentsList: []
      },

      employeeTableColumns: [
        {
          label: "Component",
          key: "name"
        },
        {
          label: "Applicable From",
          key: "revised_applicable_from"
        },
        {
          label: "Applicable Till",
          key: "revised_applicable_to"
        },
        {
          label: "Current Amount",
          key: "amount"
        },
        {
          label: "Revised Amount",
          key: "revised_amount"
        }
      ],
      employeeDocs: [
      ],
      employeeObject: {
        id: null,
        name: null,
        code: null,
        email_id: null,
        assignedComponentsList: []
      },
      updatedArray:[],
      historyDetailsArray: []
    };
  },

  mounted() {
    this.employeeObject = this.getRecord;
    this.employeeDocs = this.revisionLogRecord.log_details;
    this.getcustomArray();
  },

  activated() {
    this.employeeObject = this.getRecord;
    this.employeeDocs = this.revisionLogRecord.log_details;
    this.getcustomArray();
  },
  computed: {
    ...mapState({
      revisionLogRecord: state =>
        state.dashboard.payroll.utilities.assignFixedNonCTCcomponents
          .revisionLogRecord,
      getRecord: state =>
        state.dashboard.payroll.utilities.assignFixedNonCTCcomponents.record
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
      // revisionLogRecord: "dashboard/payroll/utilities/assignFixedNonCTCcomponents/revisionLogRecord"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    }
  },

  methods: {
    ...mapActions({}),

    cancel() {
      this.$router.go(-1);
    },

    viewHistory(record) {
      //console.log("viewHistory:", record);
    },

    dropdown(slots) {
      let idx = this.updatedArray.findIndex(obj => {
        return obj.id == slots.index + 1;
      });
      this.updatedArray.forEach((data, index) => {
        if (index != idx) {
          data.showDropdown = false;
        }
      });
      if (idx > -1) {
        this.updatedArray[slots.index].showDropdown = !this.updatedArray[
          slots.index
        ].showDropdown;
      }
    },

    getcustomArray() {
      if (this.revisionLogRecord.log_details) {
        if (this.revisionLogRecord.log_details.length) {
          this.updatedArray = [];
          this.revisionLogRecord.log_details.forEach((element, index, arr) => {
            let obj = {};
            obj["revised_date"] = this.getFormattedDate(new Date(element.updated_at));
            if (this.updatedArray.length > 0 && obj["revised_date"] !== this.updatedArray[this.updatedArray.length-1]["revised_date"]) {
              obj["log_details"] = [];
              obj.log_details.push(element);
              this.updatedArray.push(obj);
            } else if (this.updatedArray.length > 0) {
              this.updatedArray[this.updatedArray.length-1].log_details.push(element);
            } else {
              obj["log_details"] = [];
              obj.log_details.push(element);
              this.updatedArray.push(obj);
            }

          });
          //console.log("revisedRecord", this.updatedArray);
        }
      }
    },

    getFormattedDate(updated_at) {
      return (
        new Date(updated_at).getDate() +
        "/" +
        (new Date(updated_at).getMonth() + 1) +
        "/" +
        new Date(updated_at).getFullYear()
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  width: 25%;
  margin-right: 12px;
  height: 110px;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  margin-left: 20px;
}

.image {
  .alignImage {
    width: 100px;
    height: 100px;
    padding: 10px 0 0 10px;
  }
}

.action-section {
  margin: 0px;
  text-align: center;
  img {
    width: auto;
  }
  .action-menu {
    top: 0px;
    right: 54px;
    left: -182px;
    li {
      padding: 0px;
      padding: 10px 25px;
      font-weight: 500;
      &:not(:last-child) {
        border-bottom: solid 1px #97979759;
      }
    }
  }
}

.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}

.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.emp-details {
  padding: 25px 0 0 10px;
  color: #535353;
}

.heading_new {
  width: auto;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}

.table-container {
  margin-top: 30px;
  padding: 0px 20px;
}

.margin-bottom-30{
  margin-bottom: 30px;
}

.margin-bottom-150{
  margin-bottom: 150px;
}
</style>
